module.exports = {
	title: 'Input',
	notes: '',
	context: {
		id: 'component-input__id',
		label: 'Label',
		placeholder: 'Placeholder'
	}
};